import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WordpressService } from '../../services/wordpress.service';
import { map } from 'rxjs/operators';
import { JournalPost } from '../../interfaces/journal-post';
import { MetaDataService } from '../../services/metadata.service';

@Component({
  selector: 'app-page-journal-post',
  templateUrl: './page-journal-post.component.html',
  styleUrls: ['./page-journal-post.component.scss']
})
export class PageJournalPostComponent implements OnInit, OnDestroy {
  post$;
  posts: JournalPost[];
  postsList: any;
  content: any;
  postIndex: number;

  constructor(
    private route: ActivatedRoute,
    private wp: WordpressService,
    private mds: MetaDataService
  ) {}

  ngOnInit() {
    // Get post content
    this.post$ = this.route.data.pipe(map(r => r.content));
    this.post$.subscribe(post => {
      this.content = post;

      // set metadata
      const meta = {
        meta_title: this.content.acf.meta_title || this.content.title.rendered + ' | auburn',
        meta_description: this.content.acf.meta_description || this.content.acf.description,
        meta_image: this.content.acf.meta_image || (this.content.acf.image ? this.content.acf.image.url : ''),
        meta_keywords: this.content.acf.meta_keywords || null
      };
      this.mds.setMetaData(meta);
    });


    // TODO is this the best way to create postIndex? this won't work when there are more than 10 posts -sam
    this.wp.getJournalPosts(1).subscribe(res => {
      this.postsList = res && res.body ? res.body : null;
      this.postsList.map((p, i) => {
        if (p.title && this.content.title.rendered && p.title.rendered === this.content.title.rendered) {
          this.postIndex = i + 1;
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.post$) {
      this.post$.unsubscribe();
    }
  }
}
